/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as DraftDefs from './defs.defs'

const $nsid = 'app.bsky.draft.createDraft'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  draft: /*#__PURE__*/ l.ref<DraftDefs.Draft>((() => DraftDefs.draft) as any),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  id: /*#__PURE__*/ l.string({ format: 'tid' }),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Inserts a draft using private storage (stash). An upper limit of drafts might be enforced. Requires authentication. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'DraftLimitReached',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
